import { thunk } from 'redux-thunk';
import authReducer from './auth';
import brandReducer from './brand';
import conversations from './conversations';
import loadingReducer from './loading';
import notifications from './notifications';
import {applyMiddleware, combineReducers, createStore} from 'redux';

const rootReducers = combineReducers({
  auth: authReducer,
  brand: brandReducer,
  loading: loadingReducer,
  notifications,
  conversations,
});

const store = createStore(rootReducers, applyMiddleware(thunk));


export default store;
